import { Logger } from 'common/logger';
import { configureReportsAPI } from 'routes/Reports/ReportsAPI';
import { configureIamAPI, fetchUserData, normalizeAuthUser } from 'common/auth/AuthxAPI';

export const account = {
    name: 'account',
    state: {
        isLoggedIn: false,
        isAdmin: false,
        allowedScreens: {},
        allowedRoutes: [],
        token: null,
        user: {
            emailAddress: '',
            name: {},
            userId: '',
            username: '',
        },
    },

    reducers: {
        setUserData(state, payload) {
            return {
                ...state,
                user: {
                    ...state.user,
                    ...payload.user,
                },
            };
        },

        setToken(state, payload) {
            return { ...state, token: payload.token };
        },

        setIsLoggedIn(state, payload) {
            return { ...state, isLoggedIn: payload };
        },

        setIsAdmin(state, payload) {
            return { ...state, isAdmin: payload.isAdmin };
        },

        setPrivilegesConfig(state, { allowedScreens, allowedRoutes }) {
            return {
                ...state,
                allowedScreens,
                allowedRoutes,
            };
        },
    },

    effects: (dispatch) => ({
        async tokenChanged({ token }, rootState) {
            const currentToken = rootState.account.token;
            Logger.info('TokenChanged');

            // Skip reconfiguration on initial load if there's no token
            if (currentToken && token !== currentToken) {
                dispatch({ type: 'appData/reconfigureSite' });
            }
            configureReportsAPI(token);
            configureIamAPI(token);
            dispatch.account.setToken({ token });
        },

        async authorizeUser({ authUser }) {
            try {
                const { account: accountData } = await fetchUserData(normalizeAuthUser(authUser));
                dispatch.account.setUserData({ user: accountData });
                dispatch.account.setIsLoggedIn(true);
                dispatch({ type: 'appData/filterParkListByAuth' });
            } catch (e) {
                Logger.info('Authorize model error, logging out:', e);

                // Redirect to logout page
                dispatch({ type: 'router/REDIRECT', payload: { pathname: `/logout` } });
            }
        },
    }),
};
